import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { getCaInfo,getUserMintInfo ,approve,Subscribe,allowance} from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const PreSale = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)

    const [ca, setCa] = useState("");
    const [mintAmount, setMintAmount] = useState("");
    const [mintBeginTime, setMintBeginTime] = useState("");
    const [mintState, setMintState] = useState("");
    const [mintTotalAddress, setMintTotalAddress] = useState("");
    const [mintTotalAmount, setMintTotalAmount] = useState("");
    const [tokenPrice, setTokenPrice] = useState("");

    const [isMint1, setIsMint1] = useState("");
    const [isMint2, setIsMint2] = useState("");
    const [isMint3, setIsMint3] = useState("");
    const [time1, setTime1] = useState("");
    const [time2, setTime2] = useState("");
    const [time3, setTime3] = useState("");
    const [tokenAmount1, setTokenAmount1] = useState("");
    const [tokenAmount2, setTokenAmount2] = useState("");
    const [tokenAmount3, setTokenAmount3] = useState("");
    const [usdtAmount1, setUsdtAmount1] = useState("");
    const [usdtAmount2, setUsdtAmount2] = useState("");
    const [usdtAmount3, setUsdtAmount3] = useState("");

    const[qi ,setQi] = useState("")
    const [mintTotalAddress1, setMintTotalAddress1] = useState("");
    const [mintTotalAmount1, setMintTotalAmount1] = useState("");
    const [mintTotalAddress2, setMintTotalAddress2] = useState("");
    const [mintTotalAmount2, setMintTotalAmount2] = useState("");
    const [mintTotalAddress3, setMintTotalAddress3] = useState("");
    const [mintTotalAmount3, setMintTotalAmount3] = useState("");

   


    const navigate = useNavigate()//hook事件路由跳转
    
    
    

    

    
 

    const _getTuanInfo = () =>{
      
        if(props.address.length>0 && props.isLogin){
            getTuanInfo().then(res=>{
                if(res.code == 0){
                    
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    const _isApproveUsdt =  () => {
           return  new Promise(async (resolve, reject) => {
                allowance(props.address,ca,"usdt").then(res=>{
                    if(parseFloat(res)>=100){
                        
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                },err =>{
                        resolve(false)
                })
             })
        }

    const _rand = async() =>{
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(qi==1){
             if(isMint1 == true){
                    message.error(t('mint.您已经参与过认购!'))
                    return false
                }
        }else if(qi==2){
                if(isMint2== true){
                    message.error(t('mint.您已经参与过认购!'))
                    return false
                }
        }else if(qi==3){
                if(isMint3== true){
                    message.error(t('mint.您已经参与过认购!'))
                    return false
                }
        }
       
        if(!mintState){
             message.error(t('mint.暂不可认购'))
            return false
        }
        const tsS = Math.floor(Date.now() / 1000);
        if (tsS < mintBeginTime || mintBeginTime.length==0 || mintBeginTime ==0){
            message.error(t('mint.暂未开始'))
            return false
        }

        if(ca.length === 0){
            message.error(t('asset.区块合约错误'))
            return false
        }

        message.warning(t('mint.发起中请等待'),4)
        const _isApprove =await _isApproveUsdt()

        if(_isApprove == false){
            approve(ca,"usdt",99999,true).then(res=>{
                Subscribe().then(res1=>{
                    message.success(t('mint.认购成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
            },err=>{
                message.error(t('mint.操作已取消'))
                    return false
            })
        }else{
             Subscribe().then(res1=>{
                    message.success(t('mint.认购成功'))
                    setNum(num+1)
                    return false
                },err=>{
                    message.error(t('mint.操作已取消'))
                    return false
                })
        }

    } 

    const _copy =()=>{
        
            if(ca.length>0){
    
                copy(ca);message.success(t('share.已复制')+":"+ca)
    
            }
            
        }

    
    const _getCaInfo = () =>{
        if(props.address.length<=0 ){
                    
                                return false
                }
        getCaInfo().then(res=>{
            console.log(res)
            setCa(res.ca)
            setMintAmount(res.mintAmount)
            setMintBeginTime(res.mintBeginTime)
            setMintState(res.mintState)
            setMintTotalAddress(res.mintTotalAddress)
            setMintTotalAmount(res.mintTotalAmount)
            setTokenPrice(res.tokenPrice)
            setQi(res.qi)

            setMintTotalAddress1(res.mintTotalAddress1)
            setMintTotalAmount1(res.mintTotalAmount1)

            setMintTotalAddress2(res.mintTotalAddress2)
            setMintTotalAmount2(res.mintTotalAmount2)

            setMintTotalAddress3(res.mintTotalAddress3)
            setMintTotalAmount3(res.mintTotalAmount3)
        })
    }

    const _getUserMintInfo = () =>{
        if(props.address.length<=0 ){
                    
                                return false
                }
        getUserMintInfo(props.address).then(res=>{
            
            setIsMint1(res.isMint1)
            setIsMint2(res.isMint2)
            setIsMint3(res.isMint3)
            setTime1(res.time1)
            setTime2(res.time2)
            setTime3(res.time3)
            setUsdtAmount1(res.usdtAmount1)
            setUsdtAmount2(res.usdtAmount2)
            setUsdtAmount3(res.usdtAmount3)
            setTokenAmount1(res.tokenAmount1)
            setTokenAmount2(res.tokenAmount2)
            setTokenAmount3(res.tokenAmount3)
        })
    }
   




    useEffect(() => {
        // window.scrollTo(0, 0)
        _getUserMintInfo()
            _getCaInfo()
            
            //_getTuanInfo()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            

            
            
            <div style={{"backgroundColor":"#0D0918"}} className='indexBg33  w-full lg:w-1/3 h-screen overflow-hidden pt-16'>
                <main className="h-full overflow-auto  ">
                {/*  */}
                <div onClick={()=>window.history.back()} className='w-full px-2   '>
                    <div className='mt-2 w-full h-12  flex flex-row justify-start items-center'>
                        <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                        <span className='text-lg oblod text-gray-100'>{t('mint.认购')}</span>
                    </div>
                   
                </div>
                <div className='px-4 text-[11px] text-pink-500'>
                    *{t('mint.单个钱包最大认购数量100USDT，未认购成功的USDT会原路退回')}
                </div>

                <div className='w-full px-4 mt-6 flex flex-row justify-between items-center'>
                    <span className='text-white text-sm'>{t('mint.当前期数')}：{qi}</span>
                    <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
                </div>

                {/*  */}
                <div className='  mt-2 mb-9 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='w-full mb-1 mt-0 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.认购合约地址')}:</div>
                        <div onClick={_copy} className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span  className='text-xs text-gray-400 break-all'>{ca}</span>
                            <span className='text-xs text-orange-400'>[{t('mint.复制')}]</span>
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.单钱包认购限额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-xs text-gray-400 break-all'>{mintAmount} USDT</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.认购总量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-xs text-gray-400 break-all'></span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.认购价格')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-xs text-gray-400 break-all'>{tokenPrice} USDT</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.认购时间')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-xs text-gray-400 break-all'>2026-10-01 15:00 - 202610-02 15:00</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.全网认购地址数')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-xs text-gray-400 break-all'>{qi==1?mintTotalAddress1:qi==2?mintTotalAddress2:qi==3?mintTotalAddress3:""}</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.全网认购总量')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-xs text-gray-400 break-all'>{qi==1?mintTotalAmount1:qi==2?mintTotalAmount2:qi==3?mintTotalAmount3:""} USDT</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.认购状态')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        {

                            qi==1?(
                                <span className='text-xs text-green-500 break-all'>{isMint1?t('mint.已认购'):t('mint.未认购')}</span>
                            ):qi==2?(
                                <span className='text-xs text-green-500 break-all'>{isMint2?t('mint.已认购'):t('mint.未认购')}</span>
                            ):qi==3?(
                                <span className='text-xs text-green-500 break-all'>{isMint3?t('mint.已认购'):t('mint.未认购')}</span>
                            ):null
                        }
                            
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.我已认购金额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{qi==1?usdtAmount1:qi==2?usdtAmount2:qi==3?usdtAmount3:""} USDT</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.认购金额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <span className='text-lg text-pink-400 break-all'>{mintAmount} USDT</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_rand}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.去认购')}</span></button>
                    </div>
                    
                </div>

              

                

                </main>
                
            </div>
            

                
           {/* <Foot/> */}
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(PreSale);
